import React from 'react';
import Layout from '@/components/Layout';
import ContactoPadresSection from '@/components/ContactoPadresSection';

const ContactoPadresPage = ({ user, onLogout }) => {
  return (
    <Layout user={user} onLogout={onLogout}>
      <ContactoPadresSection showHeader={true} />
    </Layout>
  );
};

export default ContactoPadresPage;
